import request from '@/utils/request'

/**
 * 查询用户未读消息数量
 */
export function getUnreadCount() {
    return request({
        url: '/system/message/api/unread/count',
        method: 'get',
        loading: false
    })
}

/**
 * 获取站内信列表
 * @param {Object} params - { pageNum, pageSize }
 */
export function getMessageList(params) {
    return request({
        url: '/system/message/api/list',
        method: 'get',
        params
    })
}

/**
 * 获取站内信详细信息
 * @param {String|Number} messageId 
 */
export function getMessageDetail(messageId) {
    return request({
        url: `/system/message/api/${messageId}`,
        method: 'get'
    })
}

/**
 * 批量标记消息为已读
 * @param {Array} messageIds - 消息ID数组
 */
export function markRead(messageIds) {
    return request({
        url: '/system/message/api/markRead',
        method: 'post',
        data: messageIds
    })
}

/**
 * 删除站内信
 * @param {String|Number} messageIds - 消息ID，多个用逗号分隔
 */
export function deleteMessage(messageIds) {
    return request({
        url: `/system/message/api/${messageIds}`,
        method: 'delete'
    })
}
